import { BreadcrumbJsonLd } from "next-seo";
import { Routes } from "~/routes";
import { addBaseUrl } from "./addBaseUrl";

// // // //

interface BreadcrumbItem {
    name: string;
    href: string;
}

export function BreadcrumbSEO(props: { items: BreadcrumbItem[] }) {
    const { items } = props;

    return (
        <BreadcrumbJsonLd
            itemListElements={[
                // Always include home page
                {
                    position: 1,
                    name: "RWA.xyz",
                    item: addBaseUrl(Routes.home),
                },
                // Include additional items
                ...items.map((each, idx) => {
                    return {
                        position: idx + 2,
                        name: each.name,
                        item: addBaseUrl(each.href),
                    };
                }),
            ]}
        />
    );
}
